// react
import { ReactNode } from 'react';

// mui
import { Box, Container, Grid, Paper } from '@mui/material';

// logos
import { LogoFundsChainAlt } from '../../img/LogoFundsChainAlt';

// props
export interface GatewayProps {
	children: ReactNode;
}

export const Gateway = ({ children }: GatewayProps) => {
	return (
		<Box
			sx={(theme) => {
				return {
					backgroundColor: theme.palette.secondary.main,
					width: '100%',
					minHeight: '100vh',
				};
			}}>
			<Grid
				container
				spacing={0}
				alignItems="center"
				justifyContent="center"
				sx={{ minHeight: '100vh' }}>
				<Grid item xs={12} md={5.5} lg={4} xl={3.5}>
					<Container>
						<Grid container spacing="15">
							<Grid item xs={12}>
								<Grid container spacing={1} justifyContent={'center'} alignItems={'center'}>
									<Grid item>
										<Box
											sx={(theme) => {
												return {
													'& svg': {
														width: 180,
														margin: 'auto',
													},
												};
											}}>
											<LogoFundsChainAlt />
										</Box>
									</Grid>
								</Grid>
							</Grid>
							<Grid item xs={12}>
								<Paper
									sx={(theme) => {
										return {
											padding: theme.spacing(2),
											[theme.breakpoints.up('md')]: {
												padding: theme.spacing(3),
											},
										};
									}}>
									{children}
								</Paper>
							</Grid>
						</Grid>
					</Container>
				</Grid>
			</Grid>
		</Box>
	);
};
